module.exports = __webpack_public_path__ + "img/f842520d49830ff52eee913b329d520b.png";